export default __webpack_public_path__ + "static/media/2.5fa5f67b.jpg";